import { t } from 'i18next'

import HeaderPages from '~/components/HeaderPages'
import { useAppInfo } from '~/hooks/useAppInfo'

import { usePublisherConfig } from '../../hooks/usePublisherConfig'
import HandleSubplishers from './HandleSubplishers'
import MetricsBySubpublisher from './MetricsBySubpublisher'

/**
 * Subpublishers da campanha. Aparece quando a rede ligou a feature
 * (ou o usuário é super admin).
 */
const CampaignSubpublishers = ({
  publisherId,
  campaignData
}: {
  campaignData: CampaignView
  publisherId: PublisherId
}) => {
  const { data } = usePublisherConfig({ publisherId })

  const { superAdmin } = useAppInfo()

  const advertiserCanManageSubpublishers = Boolean(
    data?.allow_manage_subpublishers
  )

  return (
    (advertiserCanManageSubpublishers || superAdmin) && (
      <>
        <hr />
        <HeaderPages title={t('rm:Network')} />

        <HandleSubplishers
          publisherId={publisherId}
          campaignData={campaignData}
        />
        <MetricsBySubpublisher />

        <hr />
      </>
    )
  )
}

export default CampaignSubpublishers
